export enum CourseMediaTypeEnum {
  BACKGROUND = 'background',
  MAIN = 'main'
}